'use client'

import { cn } from '@mntn-dev/ui-utilities'
import type { ElementType, PropsWithChildren } from 'react'
import {
  type UseFieldGridProps,
  useFieldGrid,
} from '../../../../hooks/use-field-grid.ts'
import { type TestIds, getTestProps } from '../../../../utils/testing.ts'
import { DataListDescription } from '../../../data-list/data-list-description.tsx'
import { DataListTitle } from '../../../data-list/data-list-title.tsx'
import {
  DataListProvider,
  type UseDataListProps,
  useDataList,
} from '../../../data-list/use-data-list.ts'
import { CardDetailsAvatar } from './card-details-avatar.tsx'
import { CardDetailsItem } from './card-details-item.tsx'

export type CardDetailsProps = PropsWithChildren<
  TestIds &
    UseFieldGridProps &
    UseDataListProps & {
      as?: ElementType
      className?: string
    }
>
export const CardDetailsComponent = ({
  as,
  children,
  className,
  columnCount = 1,
  columnGap,
  dataTestId,
  dataTrackingId,
  gap,
  rowGap,
  fontSize = 'sm',
  variant = 'subtle',
}: CardDetailsProps) => {
  const context = useDataList({ fontSize, variant })
  const { fieldGridClassName } = useFieldGrid({
    columnCount,
    columnGap,
    gap,
    rowGap,
  })
  const Component = as ?? 'div'

  return (
    <DataListProvider value={context}>
      <Component
        className={cn(fieldGridClassName, className)}
        {...getTestProps({ dataTestId, dataTrackingId })}
      >
        {children}
      </Component>
    </DataListProvider>
  )
}

const CardDetailsNamespace = Object.assign(CardDetailsComponent, {
  AvatarItem: CardDetailsAvatar,
  DataItem: CardDetailsItem,
  DataItemTitle: DataListTitle,
  DataItemDescription: DataListDescription,
})

export { CardDetailsNamespace as CardDetails }
